import css from '@emotion/css';
import styled from '@emotion/styled';
import { CardBasic } from 'components/Card/Card';
import KizenErrorCard from 'components/Kizen/ErrorCard';
import { SettingsContentCard } from 'components/Card/Card';

export const BottomCardsBlock = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding-bottom: 50px;
`;

export const BottomCard = styled(CardBasic)`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: calc((100% - 20px) / 2);
  padding: 20px;

  ${({ minHeight }) =>
    minHeight &&
    css`
      min-height: ${minHeight};
    `}

  > div:last-of-type {
    flex: 1;
  }

  h3 {
    line-height: 1; // Sidestep bootstrap
    padding-bottom: 5px;
  }
`;

export const ErrorCard = styled(KizenErrorCard)`
  margin-top: -1px;
`;

export const StyledSettingsContentCard = styled(SettingsContentCard)`
  margin: 15px auto 20px;
`;
